import { createContext, useContext, useState, useCallback, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { CHAPTERS, EASE } from '../data/site';

const colorFor = (path) => {
  if (path.includes('saarthi')) return '#F9526B';
  const c = CHAPTERS.find((ch) => path.includes(ch.slug));
  return c ? c.color : '#000515';
};

const WipeCtx = createContext(() => {});
export const useWipe = () => useContext(WipeCtx);

export const WipeProvider = ({ children }) => {
  const navigate = useNavigate();
  const [panel, setPanel] = useState(null); // { color, mode: 'cover' | 'reveal' }
  const busy = useRef(false);

  const go = useCallback(
    (path) => {
      if (busy.current) return;
      busy.current = true;
      const color = colorFor(path);
      setPanel({ color, mode: 'cover' });
      setTimeout(() => {
        navigate(path);
        window.scrollTo(0, 0);
        setPanel({ color, mode: 'reveal' });
        setTimeout(() => {
          setPanel(null);
          busy.current = false;
        }, 900);
      }, 650);
    },
    [navigate]
  );

  return (
    <WipeCtx.Provider value={go}>
      {children}
      <AnimatePresence>
        {panel && (
          <motion.div
            key={panel.mode}
            data-testid="page-wipe"
            className={`fixed inset-0 z-[100] pointer-events-none ${
              panel.mode === 'cover' ? 'origin-bottom' : 'origin-top'
            }`}
            style={{ background: panel.color }}
            initial={{ scaleY: panel.mode === 'cover' ? 0 : 1 }}
            animate={{ scaleY: panel.mode === 'cover' ? 1 : 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: panel.mode === 'cover' ? 0.6 : 0.85, ease: EASE }}
          >
            <div className="bandhani-dot absolute inset-0 text-paper/[0.07]" />
          </motion.div>
        )}
      </AnimatePresence>
    </WipeCtx.Provider>
  );
};

export const WipeLink = ({ to, children, onClick, ...props }) => {
  const go = useWipe();
  return (
    <Link
      to={to}
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick(e);
        go(to);
      }}
      {...props}
    >
      {children}
    </Link>
  );
};
